var TRANS_DICT = {
  "projects": {
    "EDIT" : "Edit project",
    "LEAVE" : "Leave project",
    "DELETE" : "Delete project",
    "DUPLICATE" : "Duplicate",
    "NAME" : "Name",
    "DESCRIPTION" : "Description",
    "SIZE" : "Size",
    "LAST_VISITED_BY_ME" : "Last visited by Me",
    "LAST_MODIFIED" : "Last modified on",
    "MODIFIED" : "Modified",
    "LAST_VISITED" : "Last visited",
    "LOADING" : "Loading projects",
    "USE_FOR_NEW_TEMPLATE" : "Use as Template for a New Project",
    "NO_RESULT_FOUND": "You don't have any projects.",
	  "NO_RESULT_MESSAGE": "Please visit connect application for create a new project.",
    "NO_SEARCH_RESULT_FOUND": "No search found",
	  "NO_SEARCH_RESULT_MESSAGE": "Try adjusting your search or filter to find what you're looking for.",
    "END_OF_PAGE": "End of projects list",
    "CREATE_NEW": "Create a Project",
    "LOCKED": "Locked",
    "NO_REQUIRED_ATTRIBUTE": "No access token and api-url attributes are found. Please configure for fetch the projects from server."
  }
};
export default TRANS_DICT;